"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from "../../ui/dialog";

import Button from "../../button-v1";
import TimeInput from "../../ui/timeInput/TimeInput";
import CustomInput from "../../ui/input";

import { useForm, Controller } from "react-hook-form";
import styles from "../../../styles/case-manager-modules/DecisionModal.module.css";

const EscalationModal = ({
  isOpen,
  onClose,
  onSubmit,
  categoryText = "", 
}) => {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      note: "",
      followUpTime: {
        hh: "",
        mm: "",
        ss: "",
      },
    },
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  const submitHandler = (data) => {
    const { hh, mm, ss } = data.followUpTime;

    const totalMinutes =
      Number(hh || 0) * 60 +
      Number(mm || 0) +
      Math.round(Number(ss || 0) / 60);

    onSubmit({
      ...data,
      category: categoryText, // ✅ ensure category goes to backend
      followUpTimeMinutes: totalMinutes,
    });

    reset();
    onClose();
  };

  return (
    <Dialog open={isOpen} setOpen={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Escalate Reading</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit(submitHandler)}>
          <DialogBody className={styles.body}>

            {/* ✅ CATEGORY (READ-ONLY, PRE-FILLED)
            <CustomInput
              label="Escalation Category *"
              value={categoryText || "—"}
              disabled
              variant="outlined"
              size="small"
            /> */}

            {/* FOLLOW-UP TIME */}
            <label className={styles.label}>
              Follow-up Time / Call Duration *
            </label>

            <Controller
              name="followUpTime"
              control={control}
              render={({ field }) => (
                <TimeInput value={field.value} onChange={field.onChange} />
              )}
            />

            {/* NOTE */}
            <label className={styles.label}>Escalation Note *</label>

            <textarea
              className={`${styles.textarea} ${errors.note ? styles.textarea_error : ""}`}
              {...register("note", {
                required: "Escalation note is required",
                minLength: {
                  value: 5,
                  message: "Minimum 5 characters required",
                },
              })}
            />

            {errors.note && (
              <span className={styles.error}>
                {errors.note.message}
              </span>
            )}
          </DialogBody>

          <DialogFooter className={styles.actions}>
            <Button variant="primary" type="submit">
              Submit Escalation
            </Button>

            <Button variant="ghost" type="button" onClick={handleClose}>
              Cancel
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EscalationModal;
